import type { ChannexSystemStatus } from "@/types";
import { apiClient } from "./client";

export const channelService = {
  status: async (): Promise<ChannexSystemStatus> => {
    const { data } = await apiClient.get<ChannexSystemStatus>("/admin/channels/status");
    return data;
  },

  sync: async (): Promise<void> => {
    await apiClient.post("/admin/channels/sync");
  },
};
